import { UpperCasePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { log } from 'console';
import { jsPDF, jsPDFOptions } from "jspdf";
import { CreatePdf } from './createPdf/create-pdf.service';

@Injectable({
  providedIn: 'root'
})
export class GenerarPdfHistorialPagosService {

  COLOR_TEXT_TITLE = '#75b7b6';
  COLOR_BLACK = '#000000';
  COLOR_WHITE = '#FFFFFF';
  MARGIN_LEFT = 10;

  fecha = new Date();
  fechaFormated = this.fecha.getDate() + '-' + (this.fecha.getMonth() + 1) + '-' + this.fecha.getFullYear();

  options: jsPDFOptions = {};

  doc:any;

  headers: any[] = [
    { name: 'RECIBO', prompt: 'Recibo' },
    { name: 'FECHA', prompt: 'Fecha' },
    { name: 'CAPITAL', prompt: 'Capital' },
    { name: 'INTERES', prompt: 'Interes' },
    { name: 'SEGURO_FINANCIERO', prompt: 'Seguro financiero' },
    { name: 'INTERES_MORA', prompt: 'Interés por mora' },
    { name: 'HONORARIOS', prompt: 'Honorarios' },
    { name: 'GASTOS_COBRANZA', prompt: 'Gastos de cobranza' },
    // El campo fuente_mgracia determina el nombre del campo valor_mgracia
    { name: 'INTERES_MES_GRACIA', prompt: ''}, 
    { name: 'CUOTA_MANEJO', prompt:'Otros gastos'},// El prompt se ajustará dinámicamente
    { name: 'VALOR_FULL', prompt: 'Total' }
  ];

  /**
   * Ajusta dinámicamente el encabezado de VALOR_MGRACIA según fuente_mgracia en los datos.
   * Llama a esta función antes de generar la tabla.
   */
  setMgraciaHeader(historialPagos: any[]) {
    // Busca el primer registro con fuente_mgracia
    const mgracia = historialPagos.find(item => item.FUENTE_MGRACIA);
    if (mgracia) {
      const fuente = mgracia.FUENTE_MGRACIA.toLowerCase();
      if (fuente === 'seguro') {
        this.headers = this.headers.map(h =>
          h.name === 'INTERES_MES_GRACIA'
            ? { ...h, prompt: 'Seguro' }
            : h
        );
      } else if (fuente === 'interes_mgracia') {
        this.headers = this.headers.map(h =>
          h.name === 'INTERES_MES_GRACIA'
            ? { ...h, prompt: 'Interés mes de gracia' }
            : h
        );
      }
    }
  }

  constructor() {
    
  }

  gen(){
    this.doc = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: "letter",
      compress: true
    })

    this.doc.output('dataurlnewwindow', {filename: 'Autorizacion Debito'});
    /*let crearPdf = new CreatePdf("mm");
    crearPdf
      .header(60).img('assets/img/cabecera.png','PNG',0,0,220,80).end()
      .pagina('portrait','letter', {bottom:10, left: 10, right: 10, top: 10})
      .fontSize(9)
      .addText("prueba", 0, 0)
      .img('assets/img/logo-credijamar.png','PNG',90,20,50,25)
      .end()
      .create('prueba');
      */
  }
  async generar(datosUsuario: any, historialPagos: any[]) {
    this.setMgraciaHeader(historialPagos); 
    this.doc = new jsPDF({
      orientation: "p",
      unit: "mm",
      format: "letter",
      compress: true
    })
    
    this.doc.addImage({ imageData: 'assets/img/logo-credijamar.png', format: 'PNG', x: 90, y: 20, width: 50, height: 25 });

    this.doc.setFont("helvetica", 'normal', "bold");
    this.doc.setFontSize(16);
    this.doc.setTextColor(this.COLOR_TEXT_TITLE);
    this.doc.text('HISTORIAL DETALLADO DE PAGO', 110, 60, { align: 'center' });
    
    this.doc.setFontSize(9);
    this.doc.setTextColor(this.COLOR_BLACK);
    this.doc.text('Fecha de Generación: ' + this.fechaFormated, 110, 65, { align: 'center' });
    this.doc.text('Nombre: ' + datosUsuario.NOMBRE.toUpperCase(), this.MARGIN_LEFT, 80, { align: 'left' });
    this.doc.text('Cedula: ' + datosUsuario.N_IDE, this.MARGIN_LEFT + 110, 80, { align: 'left' });
    
    this.doc.text('Cuenta: ' + datosUsuario.CUE, this.MARGIN_LEFT, 90, { align: 'left' });
    this.doc.text('Factura: ' + datosUsuario.FACTURA, this.MARGIN_LEFT + 57, 90, { align: 'left' });
    this.doc.text('Dia de Corte: '+ datosUsuario.FEC_VENC, this.MARGIN_LEFT + 110, 90, { align: 'left' });
    
    this.doc.setFont("helvetica", 'normal', "normal");

    var headers = this.createHeaders(this.headers);
    this.doc.table(this.MARGIN_LEFT, 100, historialPagos, headers, { autoSize: true, fontSize: 7, padding: 1, headerBackgroundColor: this.COLOR_TEXT_TITLE, headerTextColor: this.COLOR_WHITE, margins: {left: 0, bottom: 15, width: 0 , top: 15}});
    //this.doc.table(this.MARGIN_LEFT-2, 100, data, headers, { autoSize: true, fontSize: 7, padding: 1, headerBackgroundColor: this.COLOR_TEXT_TITLE, headerTextColor: this.COLOR_WHITE});
    
    let pageCount = this.doc.internal.getNumberOfPages();
    for(let i = 1; i<=pageCount; i++){
      this.doc.setPage(i);
      this.addHeader();
      this.addFooter();
    }
    this.doc.save('HistorialPagos-'+datosUsuario.FACTURA);
    //this.doc.output('dataurlnewwindow', {filename: 'Autorizacion Debito'});

  }

  createHeaders(keys: any[]) {
    let result: any[] = [];
    keys.forEach(k => {
      result.push({
        id: k.name,
        name: k.name,
        prompt: k.prompt,
        align: 'center',
      })
    })
    return result;
  }

  

  addHeader() {
    this.doc.addImage({
      imageData: 'assets/img/cabecera.png',
      format: 'PNG',
      x: 0,
      y: 0,
      //width: 210,
      width: 230,
      height: 80
    });
  }

  addFooter() {
    this.doc.addImage({
      imageData: 'assets/img/cabecera.png',
      format: 'PNG',
      x: 220,
      y: 120,
      //width: 210,
      width: 235,
      height: 80,
      rotation: 180
    });
  }

  addTable(x: number, y: number, data: any[], header: any[]) {
    this.doc.table(x, y, data, header, {});
  }


}